module.exports = __webpack_public_path__ + "static/img/logo-main.199de810.png";